import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const EXPENSES_BASE_QUERY_KEY = 'expenses';

export const expensesApiQueryKeys = {
  global: () => [EXPENSES_BASE_QUERY_KEY] as const,
  byTourId: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, EXPENSES_BASE_QUERY_KEY] as const,
  byId: (tourId: string, expenseId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, EXPENSES_BASE_QUERY_KEY, expenseId] as const,
};
